"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AlpineHeader;
function AlpineHeader() {
    return Alpine.data('header', function () { return ({
        isVisible: false,
        isOpen: false,
        isCollapsed: !window.matchMedia('(min-width: 1300px)').matches,
        handleResize: function () {
            this.isCollapsed = !window.matchMedia('(min-width: 1300px)').matches;
        },
        init: function () {
            if (!this.isCollapsed) {
                this.isVisible = true;
            }
        },
        handleClick: function (item) {
            if (this.isOpen === item) {
                this.isOpen = false;
            }
            else {
                this.isOpen = item;
            }
        },
        handleSearchOpen: function (item) {
            var _this = this;
            if (this.isOpen === item) {
                setTimeout(function () {
                    _this.$refs.searchInput.focus();
                }, 500);
            }
        },
    }); });
}
